import type { Route } from 'fitify-ui-onboarding/src/types/routeTypes'

import { getRouteKey } from 'components/RoutePrefetch/RoutePrefetch.Utils'
import { ALL_VIDEOS, DEFAULT_VIDEO_VARIANT } from 'data/videos'
import type { Funnel } from 'types/state'
import type { VideoDefinition } from 'types/videos'

const getRouteVideosDefinition = (
  routeKey: string,
  funnel: Funnel,
  variant: string
) => {
  const routeVideosDefinition = Object.entries(
    Object.entries(ALL_VIDEOS[funnel]).find(([key]) => key === variant)?.[1] ||
      {}
  ).find(([key]) => key === routeKey)?.[1]

  if (routeVideosDefinition) {
    return routeVideosDefinition as Record<string, VideoDefinition>
  }
  return undefined
}

/**
 * Gets the video srcs for the given route and funnel. Videos are resolved based on the route key,
 * which should match the top level key in the funnel-specific videos definition.
 * Returns all srcs under the route — the active media-style variant is chosen by the page itself.
 */
export const getRouteVideos = (
  route: Route<string>,
  funnel: Funnel,
  variant: string = DEFAULT_VIDEO_VARIANT
): VideoDefinition[] => {
  const routeKey = getRouteKey(route, funnel)

  if (routeKey) {
    const routeVideosDefinition = getRouteVideosDefinition(
      routeKey,
      funnel,
      variant
    )
    if (routeVideosDefinition) {
      return Object.values(routeVideosDefinition)
    }
  }

  return []
}
